import UserService from "@/core/services/UserService";
import HTTPService from "@/core/services/HTTPService";

class RequestService {
  public async me() {
    if (!UserService.hasToken()) {
      return;
    }

    try {
      const res = await HTTPService.get("api/user");
      const payload = res?.data;
      if (payload == null) {
        return;
      }

      if (payload.banned === true) {
        return;
      }

      if (payload.type === "error") {
        UserService.destroyToken();
        return;
      }

      UserService.setUser(payload);
    } catch {
      UserService.destroyToken();
    }
  }
}
export default new RequestService();
